import React, { type FC } from 'react';
import { Skeleton } from 'antd';
import { Select, Space, Textarea, Text } from '@g2u/ui-kit';

import { type JsonData, type WithOptionalDataTest } from 'types';
import { Section } from 'components';
import styles from '../parts-only-job.module.scss';

export namespace SelectTechnician {
  export type Props = {
    isLoading: boolean;
    technicians: JsonData;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { technicians, isLoading } = props;

    return (
      <Section.$ title="Select Technician">
        {isLoading ? (
          <Skeleton />
        ) : (
          <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
            <Text.$ size={Text.Size.SM} type="secondary" italic>
              *If there is no technician select ‘Geeks2U Office’*
            </Text.$>

            <Select.$
              required
              dataTestId="technicianId"
              label="Technician: "
              name="technicianId"
              className={styles.partsOnlyJob__formItem}
              options={technicians}
              rules={[{ required: true }]}
              showSearch
            />
            <Textarea.$
              dataTestId="technician-note"
              name="technicianNote"
              placeholder={'Please enter a note.'}
              label="Note for Technician:"
              className={styles.partsOnlyJob__formItem}
              style={{ maxWidth: 360, height: 100 }}
            />
          </Space.$>
        )}
      </Section.$>
    );
  };
}
